export enum RecognizeCriterionEvaluator {
  Llm = "llm",
  Deterministic = "deterministic",
}
